import * as types from "./group.constant";

const defaultState = {
    formData: {
        groupName:"",
        logo:1,
    },

};

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.GROUP_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.GROUP_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
